import { environmentHttpClient } from "client/Api/httpClient";

export enum MagisterResourceKind {
	Grades = 1,
	Schedule = 2
}

export type MagisterConnectionInterests = {
	grades?: true;
	weekSchedule?: true;
	daySchedule?: true;
};

export type LiveInformationRequestModel = {
	connectionId: number;
	date: string;
	interests: MagisterConnectionInterests;
};

export enum ResultStatus {
	GeneralFailure = 0,
	Success = 1
}

export type MagisterGrade =	{
	id: number;
	className: string | null;
	date: string | null;
	description: string | null;
	value: number | null;
	valueText: string | null;
	weightingFactor: number | null;
};

export type GradesResponseModel = {
	status: Exclude<ResultStatus, ResultStatus.Success>;
	items: null;
} | {
	status: ResultStatus.Success;
	items: readonly MagisterGrade[];
};

export enum StatusKind {
	AutomaticScheduled = 1,
	WeDontKnowWhatItMeansTwo = 2,
	Changed = 3,
	WeDontKnowWhatItMeansFour = 4,
	Cancelled = 5,
	InUse = 6,
	Closed = 7
};

export enum LessonKind {
	Unknown = 0,
	Homework = 1,
	Test = 2,
	Examination = 3,
	WrittenExamination = 4,
	OralExamination = 5,
	Information = 6
};

export type MagisterAppointment = {
	id: number;
	status: StatusKind;
	location: string;
	message: string;
	description: string;
	startDateTime: string;
	finishDateTime: string;
	lessonNumberFrom: number | null;
	lessonNumberTo: number | null;
	lessonKind: LessonKind;
	lessonKindDescription: string;
	documentCount: number;
	teacherShortName: string;
};

export type ScheduleResponseModel = {
	status: Exclude<ResultStatus, ResultStatus.Success>;
	items: null;
} | {
	status: ResultStatus.Success;
	items: readonly MagisterAppointment[];
};

export type LiveInformationResponseModelData = {
	grades: GradesResponseModel;
	weekSchedule: ScheduleResponseModel;
	daySchedule: ScheduleResponseModel;
};

export type MagisterLiveInformationResponseModel = {
	connectionId: number;
	date: string;
	interests: MagisterConnectionInterests;
	isTeacher: boolean | null;
	data: LiveInformationResponseModelData;
};

export function getLiveInformation(
	requests: LiveInformationRequestModel[]
): Promise<readonly MagisterLiveInformationResponseModel[]> {
	return environmentHttpClient.post<readonly MagisterLiveInformationResponseModel[]>(
		"Workspace/LiveInformation/Magister/Get",
		requests
	);
}
